import { create } from 'zustand';
import {
  getImportantDates,
  createImportantDate,
  updateImportantDate,
  deleteImportantDate,
  bulkDeleteImportantDates,
} from '../api/importantDateService';
import logger from '../utils/logger';

// ponytail: Zustand store replacing the ImportantDateContext boilerplate
export const useImportantDateStore = create((set, get) => ({
  importantDates: [],
  loading: true,
  error: null,

  fetchImportantDates: async (params = {}) => {
    try {
      set({ loading: true, error: null });
      const response = await getImportantDates(params);
      if (response.status === 'success') {
        set({ importantDates: response.data.importantDates || [] });
      }
    } catch (err) {
      set({ error: err.message || 'Failed to fetch important dates' });
      logger.error('Error fetching important dates:', err);
    } finally {
      set({ loading: false });
    }
  },

  addImportantDate: async (data) => {
    try {
      set({ loading: true, error: null });
      const response = await createImportantDate(data);
      if (response.status === 'success') {
        set((state) => ({ importantDates: [...state.importantDates, response.data.importantDate] }));
        return response.data.importantDate;
      }
    } catch (err) {
      set({ error: err.message || 'Failed to create important date' });
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  updateImportantDate: async (id, data) => {
    try {
      set({ loading: true, error: null });
      const response = await updateImportantDate(id, data);
      if (response.status === 'success') {
        set((state) => ({
          importantDates: state.importantDates.map((d) => (d._id === id ? response.data.importantDate : d)),
        }));
        return response.data.importantDate;
      }
    } catch (err) {
      set({ error: err.message || 'Failed to update important date' });
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  deleteImportantDate: async (id) => {
    try {
      set({ loading: true, error: null });
      await deleteImportantDate(id);
      set((state) => ({ importantDates: state.importantDates.filter((d) => d._id !== id) }));
    } catch (err) {
      set({ error: err.message || 'Failed to delete important date' });
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  bulkDeleteImportantDates: async (ids) => {
    try {
      set({ loading: true, error: null });
      await bulkDeleteImportantDates(ids);
      set((state) => ({ importantDates: state.importantDates.filter((d) => !ids.includes(d._id)) }));
    } catch (err) {
      set({ error: err.message || 'Failed to delete important dates' });
      throw err;
    } finally {
      set({ loading: false });
    }
  },
}));

// ponytail: init driven by PublicDataLoader — not here
